import React, { useEffect, useCallback, useState } from 'react';
import { Icon, Spin } from 'antd';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import Widget from 'components/Widget';
import TableWithLoadMore from 'components/TableWithLoadMore';
import FormFilter from './FormFilter';
import Columns from './Columns';
import { fetchQuota, loadMoreQuota } from 'appRedux/actions/Quota';
import { fetchRole } from 'appRedux/actions/Role';
import { fetchFreq } from 'appRedux/actions/Freq';
import { fetchCategory } from 'appRedux/actions/Category';
import convertData from 'firebase/utils/convertData';
import countDataByField from 'firebase/utils/countDataByField';
import getFinalData from 'firebase/utils/getFinalData';
import getPages from 'util/getPages';


const Listing = ({ quotaList, roleList, freqList, categoryList, loading, isShowMore, fetchQuota, fetchRole, fetchFreq, fetchCategory, loadMoreQuota, loadingFreq, loadingRole, loadingCategory, currentUser }) => {
  const [toggle, setToggle] = useState(false);
  const [filterValues, setFilterValues] = useState({});
  const lastDoc = isEmpty(quotaList) ? null : quotaList[quotaList.length - 1];
  const convertedData = isEmpty(quotaList) ? [] : convertData(quotaList);
  const freq = isEmpty(freqList) ? [] : convertData(freqList);
  const categories = isEmpty(categoryList) ? [] : convertData(categoryList);
  const groups = isEmpty(convertedData) ? null : countDataByField(convertedData, 'created_at');
  const pages = isEmpty(groups) ? [] : getPages(quotaList.length / 12, groups);
  const finalData = !isEmpty(convertedData) && !isEmpty(groups) ? getFinalData(convertedData, groups) : [];
  const role = localStorage.getItem('role');
  const isAdmin = role === 'admin';
  const isLineManager = role === 'line-manager';
  const isMember = !isLineManager && !isAdmin;
  const typeListing = window.location.pathname === '/search/list-quota-campaign' ? 'campaign' : 'brand';
  const columns = isEmpty(convertedData)
    ? []
    : Columns(convertedData[0].brands, groups, convertedData.length, isAdmin, pages);
  let roles = isEmpty(roleList) ? [] : convertData(roleList, true, true);
  roles = isLineManager ? roles.filter(role => role.line_manager === currentUser || role.email === currentUser) : roles;
  const handleFetchData = useCallback(
    (filter = null) => {
      if (currentUser) {
        if (isAdmin) {
          const filterParams = filter ? { ...filter, type: typeListing } : { type: typeListing };
          setFilterValues(filterParams);
          fetchQuota({
            filter: filterParams,
          });
          return;
        }
        if (isMember) {
          const filterParams = filter ? { ...filter, created_by: currentUser, type: typeListing } : { created_by: currentUser, type: typeListing };
          setFilterValues(filterParams);
          fetchQuota({
            filter: filterParams,
          });
        }
      }
    },
    [currentUser, fetchQuota, isAdmin, isMember, typeListing]
  );

  const handleFetchDataForLineManager = useCallback(
    (filter = null) => {
      if (currentUser) {
        const members = isEmpty(roles) ? [] : roles.map(role => role.email);
        const filterParams = filter ? { ...filter, created_by: filter.created_by || [currentUser, ...members], type: typeListing } : { created_by: [currentUser, ...members], type: typeListing };
        setFilterValues(filterParams);
        fetchQuota({
          filter: filterParams,
        });
      }
    },
    [currentUser, fetchQuota, roles, typeListing]
  );

  const handleLoadMoreData = (lastDoc = null) => {
    loadMoreQuota({
      lastDoc,
      filter: filterValues,
    });
  };

  const handleToggle = () => {
    setToggle(!toggle);
  };

  useEffect(
    () => {
      fetchRole();
      fetchFreq();
      fetchCategory();
      handleFetchData();
    },
    [fetchCategory, fetchFreq, fetchRole, handleFetchData]
  );

  useEffect(() => {
    if (isLineManager && !loadingRole && isEmpty(quotaList) && currentUser) {
      const members = roles.map(role => role.email);
      const filterParams = { created_by: [currentUser, ...members] };
      setFilterValues(filterParams);
      fetchQuota({
        filter: filterParams,
      });
    }
  }, [currentUser, fetchQuota, isLineManager, loadingRole, quotaList, roles]);

  return (
    <Spin spinning={!currentUser} tip="Đang tải dữ liệu...">
      <Widget
        styleName="gx-order-history"
        title={<h2 className="h4 gx-text-capitalize gx-mb-0">Search by {typeListing}</h2>}
        extra={
          <p onClick={handleToggle} className="gx-text-primary gx-mb-0 gx-pointer">
            {toggle ? (
              <>
                <Icon type="up-circle" /> Đóng tìm kiếm
              </>
            ) : (
              <>
                <Icon type="search" /> Bạn cần tìm kiếm dữ liệu ?
              </>
            )}
          </p>
        }
      >
        {toggle && <FormFilter loadingCategory={loadingCategory} categories={categories} loadingFreq={loadingFreq} isMember={isMember} freq={freq} roles={roles} onSearch={filter => isLineManager ? handleFetchDataForLineManager(filter) : handleFetchData(filter)} />}
        <TableWithLoadMore
          rowClassName={(r, i) => {
            return i === groups[r.created_at].from && i !== 0 ? 'first-row' : pages.includes(i) ? 'sample-row' : '';
          }}
          className="table-quotas"
          rowKey={r => `${r.created_at}_${r.index}`}
          columns={columns}
          data={finalData}
          loading={loading}
          isShowMore={isShowMore}
          onLoadMore={() => handleLoadMoreData(lastDoc)}
          numRows={quotaList.length / 12}
        />
      </Widget>
    </Spin>
  );
};

const mapStateToProps = ({ quota, auth, role, freq, category }) => {
  const { data: quotaList = [], loading, isShowMore } = quota;
  const { data: roleList = [], loading: loadingRole } = role;
  const { data: freqList = [], loading: loadingFreq } = freq;
  const { data: categoryList = [], loading: loadingCategory } = category;
  const { currentUser } = auth;
  return { quotaList, roleList, loading, isShowMore, currentUser, freqList, categoryList, loadingCategory, loadingFreq, loadingRole };
};

export default connect(
  mapStateToProps,
  { fetchQuota, loadMoreQuota, fetchRole, fetchFreq, fetchCategory }
)(Listing);
